import React, { useState, useEffect } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import SearchableTable from "../../../components/Tables/SearchableTable";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import { ProductColumns } from "../../../assets/Columns/ProductColumns";
import CreateProductModal from "../../../components/Modals/CreateProductModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../../store/Slices/ProductSlice";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteProductsByIdApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";
import EditCustomerModal from "../../../components/Modals/EditCustomerModal";
import EditProductModal from "../../../components/Modals/EditProductModal";
import { useNavigate } from "react-router-dom";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";
import { fetchSubCategories } from "../../../store/Slices/SubCategorySlice";
import { SubCategoryColumns } from "../../../assets/Columns/SubCategoryColumns";

const SubCategories = () => {
  const [SearchText, setSearchText] = useState("");
  const [OpenModal, setOpenModal] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState({});

  const dispatch = useDispatch();
  const SubCategoriesState = useSelector((state) => state.SubCategoriesState);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchSubCategories());
  }, [dispatch]);

  return (
    <BodyWrapper>
      <Header
        title="SubCategories"
        desc="Overview of your Sub Categories management"
        Back={true}
      >
        <CustomBtn
          title={"Create New"}
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </Header>
      <div className="w-full mt-10 flex justify-center items-center">
        {SubCategoriesState.loading ? (
          <div className="flex flex-1 justify-center items-center">
            <FetchingLoading />
          </div>
        ) : (
          SubCategoriesState.data.length !== 0 && (
            <SearchableTable
              setOpenEditModal={setOpenEditModal}
              setOpenDeleteModal={setOpenDeleteModal}
              setSelected={setSelected}
              SearchPlaceholder={"Search Product Name..."}
              SearchText={SearchText}
              setSearchText={setSearchText}
              CurrentData={SubCategoriesState.data}
              //   CurrentData={CategoryState.data.filter((dt) =>
              //     SearchText === ""
              //       ? true
              //       : dt.title.toLowerCase().startsWith(SearchText.toLowerCase())
              //   )}
              Columns={SubCategoryColumns}
            />
          )
        )}
      </div>

      {OpenModal && (
        <CreateProductModal Open={OpenModal} setOpen={setOpenModal} />
      )}
      {OpenEditModal && (
        <EditProductModal
          Open={OpenEditModal}
          setOpen={setOpenEditModal}
          currentProduct={Selected}
        />
      )}
      {OpenDeleteModal && (
        <DeleteModal
          Open={OpenDeleteModal}
          setOpen={setOpenDeleteModal}
          Loading={Loading}
          onSubmit={async () => {
            setLoading(true);
            try {
              const response = await DeleteProductsByIdApi(Selected._id);
              if (response.data.success) {
                setOpenDeleteModal(false);
                SuccessToast("Product added successfully");
                dispatch(fetchProducts());
              } else {
                ErrorToast(response.data.error?.msg);
              }
            } catch (err) {
              console.log(err);
              ErrorToast("Failed to add Product");
            }
            setLoading(false);
          }}
        />
      )}
    </BodyWrapper>
  );
};

export default SubCategories;
